import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    cancelBtn: {
        display: 'flex',
        justifyContent: 'flex-end',
        padding: 5,
        cursor: 'pointer'
    },
    titleClass: {
        color: theme.palette.grey.primary,
        gontWeight: 500
    },
    readMoreText: {
        color: theme.palette.primary.main,
        fontSize: '14px',
        fontWeight: 500,
        cursor: 'pointer'
    },
    dialogTitleClass: {
        paddingTop: '4px'
    },
    formButtonInput: {
        textTransform: 'none',
        fontWeight: '500',
        fontSize: '14px',
        width: '100%',
        color: theme.palette.grey[900],
        border: `1px solid rgba(0, 0, 0, 0.23)`,
        borderRadius: '8px',
        height: '50px',
        display: 'flex',
        justifyContent: 'start',
        paddingLeft: '14px',
        gap: '16px',
        background: 'white'
    },
    formButtonInputError: {
        textTransform: 'none',
        fontWeight: '500',
        fontSize: '14px',
        width: '100%',
        color: theme.palette.grey[900],
        border: `1px solid rgba(244, 67, 54, 1)`,
        borderRadius: '8px',
        height: '50px',
        display: 'flex',
        justifyContent: 'start',
        paddingLeft: '14px',
        gap: '16px',
        background: theme.palette.grey[50]
    },
    menuBox: {
        padding: theme.spacing(2)
    },
    greyText: {
        color: theme.palette.grey[500],
        fontWeight: 500,
        fontSize: '12px'
    },
    searchInputDiv: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            alignItems: 'flex-start'
        }
    },
    childAgeBox: {
        display: 'grid',
        gridTemplateRows: 'auto',
        gridTemplateAreas: "'childAge' 'childAge' 'childAge'",
        gridTemplateColumns: '28% 28% 28%',
        gridColumnGap: '20px'
    },
    passengerText: {
        display: 'flex',
        alignItems: 'center'
    },
    paxCounterContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: 'fit-content',
        border: `1px solid ${theme.palette.primary.light}`,
        borderRadius: theme.spacing(2),
        width: 130
    },
    paxCount: {
        padding: theme.spacing(0, 2),
        backgroundColor: theme.palette.primary.light
    }
}));

export default useStyles;
